import React, { useState, useEffect } from "react";
import {Input, Form, Col, Row, Button, Select, DatePicker, Modal, notification, Collapse, Tooltip} from "antd";
import {SendOutlined, ExclamationCircleOutlined, InfoCircleOutlined} from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { defaultValidateMessages } from "./Helper";
import { ColumnHelper } from "util/TableHelper";
import moment from 'moment';
const { TextArea } = Input;
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const TosCreateOrderForm = (props) => {
  const { confirm } = Modal;
  const [loading, setLoading] = useState(false);
  const [defaultValue, setDefaultValue] = useState();
  const [bankSelect, setBankSelect] = useState({
    data: [],
    loading: true,
  });
  const [form] = Form.useForm();
  const [bankUSeWebService, setBankUSeWebService] = useState(false);
  const today = moment().format('DD.MM.YYYY');
  const [bankUsePdf, setBankUsePdf] = useState(false);


  useEffect(() => {
    getPayments();
    setDefaultValue();
  }, [props.selectedCurrencyId]);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);
  const directiveSuccess = type => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'İşlem Başarılı.',
        duration: 2,
    });
  };
  const directiveError = type => {
    notification[type]({
      message: 'HATA',
      description:
        'İşlem Başarısız.',
        duration: 2,
    });
  };
  const getPayments = () => {
    setBankSelect({
      ...bankSelect,
      loading: true,
    });

    RequestHandler.get(`/TenantPaymentAccount?$filter=currencyId eq ${props.selectedCurrencyId}`).then((response) => {
     const defaultValue = response.value.filter(x => x.isDefault);

      if(defaultValue.length > 0) {
        setDefaultValue(defaultValue[0].id);
        setBankUSeWebService(defaultValue[0].isUseWebService);

        if(defaultValue[0].isUseWebService) {
          form.setFieldsValue({"paymentDate": moment() })
        }
      }

      setBankSelect({
        data: response.value,
        loading: false,
      });
    });
  };

  const onFinish = (values) => {
    values.paymentDate = values.paymentDate.format("YYYY-MM-DD HH:mm:ss");
    var total = 0;
    props.selectedPayments.forEach((payment) => (total += payment.amount));
    values.Amount = total;
      RequestHandler.post(`/Directive`, values,false).then((response) => {
        setLoading(false);
        if (response.success) {
          if(response.data === null){
            showConfirm(values);
          }else{
            getPayments();
            form.resetFields();
            if (props.onSuccess) props.onSuccess();
            directiveSuccess('success');
            setTimeout(() => {
              window.location.reload();
            }, 2500);
          }
        }else{
           if(!response.message) {
             directiveError('error');
          }
        }
      });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };
  const handleValue = (value) => {
    setDefaultValue(value);

    let bank = bankSelect.data.find(x => x.id === value);

    if(bank) {

      if(bank.isUseWebService) {
        form.setFieldsValue({"paymentDate": moment() })
      }

      setBankUSeWebService(bank.isUseWebService);
      setBankUsePdf(bank.isUsePdf);
    }
  }
  function disabledDate(current) {
    return moment().add(-1, 'days') >= current
  }
  const showConfirm = (values) => {
    setLoading(true);
    confirm({
      title: 'Ödeme tarihi ve işlem tarihi aynı değil!',
      icon: <ExclamationCircleOutlined />,
      content: 'Ödeme tarihlerini talimat tarihi ile aynı yapıp devam etmek ister misiniz?',
      cancelText: 'Hayır',
      okText:'Evet',
      onOk() {
        values.IsChangeDate = true;
        RequestHandler.post(`/Directive`, values).then((response) => {

          if (response.success) {
              getPayments();
              form.resetFields();
              if (props.onSuccess) props.onSuccess();
              setTimeout(() => {
                setLoading(false);
                window.location.reload();
              }, 2500);
          }

        });
      },
      onCancel() {

      },
    });
  }
  const getPaymentTotalAmount = () => {
    let total = 0;

    if (!props.selectedPayments) {
      return ColumnHelper.renderDecimal(total);
    }

    props.selectedPayments.forEach((payment) => (total += payment.amount));

    return new Intl.NumberFormat("tr-TR", {
      style: "currency",
      currency: props.selectedCurrencyCode,
      minimumFractionDigits: 2,
    }).format(total);
  };
  return (
    <Form
      {...formItemLayout}
      validateMessages={defaultValidateMessages}
      form={form}
      name="tosPaymentAdd"
      initialValues={{
        remember: true
      }}
      fields={[
        {name:"tenantPaymentAccountId",value:defaultValue}
      ]}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>
          <Form.Item name="paymentIds" hidden rules={[{ required: true }]} />

          <Form.Item label="Toplam Ödeme Sayısı">
            {props.selectedPayments?.length}
          </Form.Item>

          <Form.Item label="Toplam Tutar">{getPaymentTotalAmount()}</Form.Item>


          <Form.Item
            name="tenantPaymentAccountId"
            label= "Gönderen Banka Kodu"
            rules={[{ required: true }]}
          >
              <Select
                allowClear
                showSearch
                placeholder="Seçiniz"
                onChange={handleValue}
                value={defaultValue === "" ? null : defaultValue}
                filterOption={(input, option) =>
                  option.children[0]
                    .toLocaleLowerCase("tr-TR")
                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                }

                loading={bankSelect.loading}
              >
                {bankSelect.data.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name} - {item.iban}
                  </Select.Option>
                ))}
              </Select>

            {bankUsePdf ? <span style={{ color: 'red' }}>Bağlantı tipinize göre talimatınız bankaya gönderilmemektedir.</span> : ""}

          </Form.Item>





          {bankUSeWebService ?
            <>

              <Form.Item
                label="Ödeme Tarihi"
                name="paymentDate"
              >
                {today} <Tooltip title="Web servis kullanımında yalnızca bugün tarihli ödemeler çıkmaktadır." ><InfoCircleOutlined /></Tooltip>
              </Form.Item>
            </> :
            <>
              <Form.Item
                label="Ödeme Tarihi"
                name="paymentDate"
                rules={[{ required: true }]}
              >
                <DatePicker disabledDate={disabledDate} format="DD.MM.YYYY" />
              </Form.Item>
            </>}
          <Form.Item
                label="Açıklama"
                name="Description"
            >
                <TextArea rows={4} />
            </Form.Item>
          <Col style={{ textAlign: "right" }}>
            <Button
              type="primary"
              icon={<SendOutlined />}
              htmlType="submit"
              onClick={() => setLoading(true)}
              loading={loading}
            >
              Talimat Oluştur
            </Button>
          </Col>
        </Col>
      </Row>
    </Form>
  );
};
export default TosCreateOrderForm;
